import { call, put, takeEvery } from 'redux-saga/effects';
import { checkPermission } from '../../requests/check_permission_request';
import { checkPermissionForViewRequestSuccess } from '../actions/check_permission.actions';
import { CHECK_PERMISSION_FOR_VIEW_REQUEST } from '../constants/check_last_route_and_permission.constants';

function* checkPermissionForViewRequest({ urls }) {
    const checked_urls = {}; let
        url;
    for (url of urls) {
        const { msg } = yield call(checkPermission, url);
        checked_urls[url] = msg === 'Access granted';
    }
    yield put(checkPermissionForViewRequestSuccess(checked_urls));
}

export default function* checkPermissionForViewSaga() {
    yield takeEvery(CHECK_PERMISSION_FOR_VIEW_REQUEST, checkPermissionForViewRequest);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/check_permissions_for_view.saga.js